import { GetInventorySuccessResponseInfo, PagingOptions } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { IGetDeletionBusinessResult } from '../pages/interfaces/entities/IGetDeletionBusinessResult';
import { IDeletionBusiness } from '../pages/interfaces/entities/IDeletionBusiness';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 * 削除ページ表示情報のadapter
 */
export class GetDeletionBusinessAdapter {
  /**
   * infra層からのデータをUI層に変換する
   * @param response - Order
   */
  adaptUiData = (response: GetInventorySuccessResponseInfo): IGetDeletionBusinessResult => {
    const deletionBusinesses: IDeletionBusiness[] = [];
    const pagingOptions = response.pagingOptions as PagingOptions;
    response.data?.forEach((aggregateBusiness) => {
      deletionBusinesses.push({
        businessId: aggregateBusiness.aggregateBusinessId ?? '--',
        warehouseNumber: aggregateBusiness.warehouseNumber ?? '--',
        warehouse: aggregateBusiness.warehouse ?? '--',
        supplierNumber: aggregateBusiness.supplierNumber ?? '--',
        supplierName: aggregateBusiness.supplierName ?? '--',
        businessNumber: aggregateBusiness.businessNumber ?? '--',
        businessName: aggregateBusiness.businessName ?? '--',
        package: Number(aggregateBusiness.package) ?? 0,
        unit: aggregateBusiness.unit ?? '--',
        manufacturer: aggregateBusiness.manufacturer ?? '--',
        customerNumber: '--',
        customerName: '--',
        salesDestinationNumber: '--',
        salesDestinationName: '--',
        endUser: '--',
        aggregateBusinessResponsibleUsers:
          aggregateBusiness.aggregateBusinessResponsibleUsers?.map((user) =>
            UserAccountFactory.create({ email: user.id, name: user.name })
          ) ?? [],
        baseBusinessResponsibleUsers: [UserAccountFactory.create({ email: '', name: '' })],
        updatedAt: aggregateBusiness.updateAt ?? -1,
      });
    });
    return {
      result: deletionBusinesses,
      pagingOptions: { ...pagingOptions },
    };
  };
}
